export const TITLE = 'title'
export const SHORT_DESCRIPTION = 'short_description'
export const ORGANISATION_UUIDS = 'organisation_uuids'
export const USER_TYPE_UUIDS = 'user_type_uuids'
export const CATEGORY_UUID = 'category_uuid'
export const SUB_CATEGORY_UUID = 'sub_category_uuid'
export const UPDATE_FREQUENCY = 'update_frequency'
export const AGENCY = 'agency'
export const PUBLISHED = 'published'
export const IMAGE_META = 'image_meta'
export const DESCRIPTION_META = 'description_meta'
export const NAME = 'name'
export const INTRODUCTION = 'introduction'
export const QLIK_URL = 'qlik_url'
export const PASSWORD = 'password'
export const FIRST_NAME = 'first_name'
export const LAST_NAME = 'last_name'
export const EMAIL = 'email'
export const USER_TYPE_UUID = 'user_type_uuid'
export const ATTACHMENT_FILE = 'attachment_file'
export const SITES = 'site'
export const QLIK_FILTER_URL = 'qlik_filters_url'
export const ASSOCIATED_DATASET = 'associated_dataset'
export const FILE_NAME = 'file_name'
export const ARTICLE_UUID = 'article_uuid'
export const TAG_UUID = 'tag_uuid'
export const TEMPLATE_UUID = 'template_uuid'
export const SEND_EMAILS = 'send_emails'
export const FORCE_SEND_EMAILS = 'force_emails'
export const SITE_COLOR = 'site_primary_colour'
export const GROUP_UUID = 'group_uuid'
export const SPECIAL = 'special'
export const AUTHOR = 'author'
export const LANDING_PAGE = 'landing_page'
export const DRAFT = 'is_draft'
export const WEBPAGE_CHECKBOX = 'webpage'
export const SHOW_TOGGLE = 'show'

export const ARTICLE_FIELDS = {
  CATEGORY_UUID,
  ORGANISATION_UUIDS,
  SHORT_DESCRIPTION,
  TITLE,
  UPDATE_FREQUENCY,
  USER_TYPE_UUIDS
}

export const DISCOVERY_FIELDS = {
  CATEGORY_UUID,
  ORGANISATION_UUIDS,
  QLIK_URL,
  SHORT_DESCRIPTION,
  TITLE,
  USER_TYPE_UUIDS
}

export const CATEGORY_RESET = [
  SUB_CATEGORY_UUID,
  ORGANISATION_UUIDS,
  USER_TYPE_UUIDS
]

export const SUB_CATEGORY_RESET = [
  ORGANISATION_UUIDS,
  USER_TYPE_UUIDS
]
